import { BASE_URL } from "@/Routes";
import { SavedPaymentMethod } from "./paymentCards.types";

export const fetchPaymentMethods = async (token: string) => {
  const req = await fetch(`${BASE_URL}/payments/methods`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const data = await req.json() as SavedPaymentMethod[]
  return data
};

export const deletePaymentMethod = async (token: string, id: string): Promise<any> => {
  console.log("TOKEN", token);
  console.log("ID", id);
  const req = await fetch(`${BASE_URL}/payments/card/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  const data = await req.json() as SavedPaymentMethod[]
  return data

}

export const createSetupIntent = async (token: string) => {
  try {
    const req = await fetch(`${BASE_URL}/payments/setup-intent`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await req.json()
    return data

  } catch (error) {
    console.error(error);
  }
};



